import { Component, Input, OnInit } from '@angular/core';
import {
    Treatment,
    TreatmentUnitType,
} from '../../../../shared/state/treatment/treatment.model';
import { LibraryService } from '../../../../core/services/library/library.service';
import * as moment from 'moment';
import { FLOW_DATE_FULL_FORMAT_ABBR } from 'src/app/core/constants';

@Component({
    selector: 'app-treatment-item',
    templateUrl: './treatment-item.component.html',
    styleUrls: ['./treatment-item.component.scss'],
})
export class TreatmentItemComponent implements OnInit {
    @Input() treatment: Treatment;
    @Input() appDelegate: boolean;

    /** Flowwwer template */
    FLOW_DATE_FULL_FORMAT_ABBR = FLOW_DATE_FULL_FORMAT_ABBR;

    constructor(private libraryService: LibraryService) {}

    ngOnInit(): void {}

    public getTreatmentInfo(available: string, initial: string, isFlatRate: boolean): string {
        let text = '';

        switch (this.treatment.unitType) {
            case TreatmentUnitType.minutes:
                text = this.libraryService.getLabel('app_minutes_available_of');
                break;
            case TreatmentUnitType.shots:
                text = this.libraryService.getLabel('app_shots_available_of');
                break;
            case TreatmentUnitType.units:
                text = this.libraryService.getLabel('app_units_available_of');
                break;
            default:
                text = !isFlatRate ? this.libraryService.getLabel(
                    'app_sessions_available_of'
                ) : this.libraryService.getLabel('app_credits_available_of');
                break;
        }

        text = text.replace('###1###', available);
        text = text.replace('###2###', initial);
        return text;
    }

    /** Flowwwer template */
    getDateMoment() {
        return moment(this.treatment.date, 'DD/MM/YYYY');
    }
}
